import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  title: {
    color: theme.palette.black.dark,
    fontSize: '28px',
    fontWeight: 600,
    margin: 0,
  },
  subTitle: {
    fontSize: '20px',
    color: theme.palette.primary.main,
    fontWeight: 600,
    marginTop: '10px',
    marginBottom: '16px',
  },
  text: {
    fontSize: '14px',
    color: theme.palette.grey.grey400,
  },
  singleTp: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '7px',
    background: '#FFF',
    boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.07)',
    padding: '11px 10px',
    marginTop: '18px',
    marginBottom: '18px',
  },
  infosTp: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '10px'
  },
  infosTpName: {
    fontSize: '14px',
    fontWeight: 600,
    color: theme.palette.primary.primary800,
    lineHeight: '130%',
    '&::first-letter': {
      textTransform: 'uppercase',
    },
  },
  infosTpFunction: {
    fontSize: '10px',
    color: theme.palette.grey.grey400,
    lineHeight: '120%',
    '&::first-letter': {
      textTransform: 'uppercase',
    },
  },
}));

export default useStyles;
